import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import RedirectComponent from './components/RedirectComponent';

// AWS Amplify is configured in global.js and aws-exports.js

// Import global configuration for API auth headers
import './global';
import './styles/base.css';
import './styles/management.css';
import './App.css';
import '@aws-amplify/ui-react/styles.css';

import EventListScreen from './screens/EventListScreen';

import EventDetailScreen from './screens/EventDetailScreen';
import CreateEventScreen from './screens/CreateEventScreen';
import EditEventScreen from './screens/EditEventScreen';

import GuestListScreen from './screens/GuestListScreen';
import EditGuestScreen from './screens/EditGuestScreen';
import CreateGuestScreen from './screens/CreateGuestScreen';
import GuestImportScreen from './screens/GuestImportScreen';

import InvitationListScreen from './screens/InvitationListScreen';
import InvitationDetailScreen from './screens/InvitationDetailScreen';
import EditInvitationScreen from './screens/EditInvitationScreen';
import CreateInvitationScreen from './screens/CreateInvitationScreen';
import InvitationGuestConfirmScreen from './screens/InvitationGuestConfirmScreen';
import InvitationConfirmationScreen from './screens/InvitationConfirmationScreen';


import OpenInvitationScreen from './screens/OpenInvitationScreen';
import OpenInvitationRecapScreen from './screens/OpenInvitationRecapScreen';

import ProfileScreen from './screens/ProfileScreen';

const ShortLinkInviteRedirect = () => {
  const { code } = useParams();
  return <Navigate to={`/invite/${code}`} replace />;
};

const ShortLinkRecapRedirect = () => {
  const { code } = useParams();
  return <Navigate to={`/invite/${code}/recap`} replace />;
};

function App() {


  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes that don't require authentication */}
        <Route path="/invite/:code" element={<OpenInvitationScreen />} />
        <Route path="/invite/:code/recap" element={<OpenInvitationRecapScreen />} />
        <Route path="/i/:code/recap" element={<ShortLinkRecapRedirect />} />
        <Route path="/i/:code" element={<ShortLinkInviteRedirect />} />
        <Route path="/public/*" element={null} /> {/* Allow access to static files */}

        {/* Protected routes that require authentication */}
        <Route path="/*" element={
          <Authenticator>
            {({ signOut, user }) => (
              <div className="app-wrapper">
                <header className="app-header">
                  <h1 className="app-header__title">Event App</h1>
                </header>
                <main className="app-main">
                  <Routes>
                    <Route path="/" element={<EventListScreen />} />
                    <Route path="/profile" element={<ProfileScreen />} />
                    <Route path="/profile/domains" element={<ProfileScreen />} />

                    <Route path="/events" element={<EventListScreen />} />
                    <Route path="/events/create" element={<CreateEventScreen />} />
                    <Route path="/events/:eventId" element={<EventDetailScreen />} />
                    <Route path="/events/:eventId/edit" element={<EditEventScreen />} />

                    <Route path="/guests/:eventId" element={<GuestListScreen />} />
                    <Route path="/guests/:eventId/create" element={<CreateGuestScreen />} />
                    <Route path="/guests/:eventId/import" element={<GuestImportScreen />} />
                    <Route path="/guests/:eventId/:guestId" element={<EditGuestScreen />} />

                    <Route path="/invitations/:eventId" element={<InvitationListScreen />} />
                    <Route path="/invitations/:eventId/create" element={<CreateInvitationScreen />} />
                    <Route path="/invitations/:eventId/confirm" element={<InvitationConfirmationScreen />} />
                    <Route path="/invitations/:eventId/:invitationId" element={<InvitationDetailScreen />} />
                    <Route path="/invitations/:eventId/:invitationId/edit" element={<EditInvitationScreen />} />
                    <Route path="/invitations/:eventId/:invitationId/confirm" element={<InvitationGuestConfirmScreen />} />

                    <Route path="*" element={<RedirectComponent />} />
                  </Routes>
                </main>
              </div>
            )}
          </Authenticator>
        } />
      </Routes>
    </BrowserRouter>
  );
}



export default App;
